import React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import PatientTabInfo from './patientTabInfo';
import PatientTabOrders from './patienTabOrders';
import PatientTabPrescriptions from './patientTabPrescriptions';
import PatientTabPoints from './patientTabPoints';

const PatientTabMenu = ({ patientInfo, orders: propsOrders, points, loadOrder, loadPoints, changePage, handleTabs, tabValue, store, prescriptions, loadPrescriptions, hidepoints, handleChange, orderDropDownValue, isVape = false, hideBCRewards = false }) => {
    const { orders, pagination } = propsOrders || {};

    return (
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0 mt-2 text-center">
            <Tabs
                value={tabValue}
                onChange={handleTabs}
                id="Patient-Menu"
                className="Menu-tabs-viewpage"
            >
                <Tab
                    value="information"
                    label="Information"
                    className="Tab-div"
                />
                <Tab
                    value="history"
                    label="Orders History"
                    onClick={() => loadOrder()}
                />
                {!hidepoints && !hideBCRewards && (
                    <Tab
                        value="points"
                        label="Points History"
                        onClick={() => loadPoints()}
                    />
                )}
            </Tabs>
            <TabPanel value={tabValue} index="information">
                <PatientTabInfo patientInfo={patientInfo} />
            </TabPanel>
            <TabPanel value={tabValue} index="history">
                <PatientTabOrders orders={orders} orderDropDownValue={orderDropDownValue} pagination={pagination} handleChange={handleChange} changePage={changePage} />
            </TabPanel>
            <TabPanel value={tabValue} index="points">
                <PatientTabPoints points={points.points} pagination={points.pagination} changePage={changePage} />
            </TabPanel>
        </div>
    );
};

const TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`tabpanel-${index}`}
        aria-labelledby={`tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
      </div>
    );
  }



export default PatientTabMenu;
